const NODE_ENV = process.env.NODE_ENV || 'development';

const config = {
  development: {
    IQBASE: 'http://localhost:3001',
  },
  staging: {
    IQBASE: 'https://stage-iqapi.homelane.com',
  },
  production: {
    IQBASE: 'https://iqapi.homelane.com',
  },
};

export default config[NODE_ENV];



// WEBPACK FOOTER //
// ./src/env/index.js